import { CustomHeader } from "@/components/CustomHeader";
import { ThemedText } from "@/components/ThemedText";
import { ThemedView } from "@/components/ThemedView";
import Constants from "expo-constants";
import { useRouter } from "expo-router";
import React from "react";
import { useTranslation } from "react-i18next";
import { StyleSheet, TouchableOpacity } from "react-native";

const SettingsPage = () => {
  const router = useRouter();
  const { t } = useTranslation();
  const version = Constants.expoConfig?.version ?? "0.0.0";
  const buildSha =
    (Constants.expoConfig?.extra?.buildSha as string | undefined) ?? "dev";

  return (
    <>
      <CustomHeader
        title={t("SETTINGS")}
        type="subtitle"
        variant="tab"
        showBackButton
      />
      <ThemedView style={styles.container}>
        <TouchableOpacity
          style={styles.listItem}
          onPress={() => router.push("/settings-default-home" as never)}
        >
          <ThemedText style={styles.listItemTitle}>
            {t("DEFAULT_HOME")}
          </ThemedText>
        </TouchableOpacity>
        <TouchableOpacity
          style={styles.listItem}
          onPress={() => router.push("/settings-plates" as never)}
        >
          <ThemedText style={styles.listItemTitle}>{t("PLATES")}</ThemedText>
        </TouchableOpacity>
        <TouchableOpacity
          style={styles.listItem}
          onPress={() => router.push("/settings-notifications" as never)}
        >
          <ThemedText style={styles.listItemTitle}>
            {t("NOTIFICATIONS")}
          </ThemedText>
        </TouchableOpacity>
        <TouchableOpacity
          style={styles.listItem}
          onPress={() => router.push("/settings-signin-methods" as never)}
        >
          <ThemedText style={styles.listItemTitle}>
            {t("SIGN_IN_METHODS")}
          </ThemedText>
        </TouchableOpacity>

        <ThemedText style={styles.versionText}>
          {t("APP_VERSION", { version, buildSha })}
        </ThemedText>
      </ThemedView>
    </>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 20,
  },
  listItem: {
    paddingVertical: 16,
    borderBottomWidth: 1,
    borderBottomColor: "#e5e7eb",
  },
  listItemTitle: {
    fontSize: 16,
    fontWeight: "600",
  },
  versionText: {
    marginTop: "auto",
    paddingTop: 24,
    fontSize: 12,
    lineHeight: 16,
    textAlign: "center",
    color: "#6B7280",
  },
});

export default SettingsPage;
